export enum Contexts {
  ADMIN = "admin",
  CLIENT = "client",
  GUEST = "guest",
  // this should be used only with {withAccessToken: false}
  NO_CONTEXT = "",
}
